import Menu from "../../components/Main/Menu";
import Header from "../../components/Header";
import { ContainerStyled } from "./style";

const Community = () => {
  return (
    <ContainerStyled>
      <Header />
      <Menu />
      <h1>comunidade</h1>
    </ContainerStyled>
  );
};

export default Community;
